import React, { useState } from 'react';
import Dialog from '@material-ui/core/Dialog';
import ReferralCodeCard from '../ReferralCodeCard';
import { css } from '@emotion/core';
import { useSelector } from 'react-redux';
import useSubmitReferralCode from 'client/hooks/useSubmitReferralCode';
import { REFERRAL_CODE_API_FAIL_REASON } from 'client/utils/referralCode';
import i18next from 'i18next';

export default function DialogReferralCode({
    onClose = () => {},
    onClick = () => {},
    isShowCloseButton
}) {
    const [isLoading, setLoading] = useState(false);
    const { referralCodeCard = {} } = useSelector(s => s.settingMGMReferral);
    const [value, setValue] = useState('');
    const [error, setError] = useState('');
    const handleSubmit = useSubmitReferralCode();

    const handleClick = async () => {
        if (value.trim().length > 0) {
            setLoading(true);

            const submitResp = await handleSubmit(value);

            if (submitResp.success) {
                setError('');
                onClick();
                onClose();
            }

            if (submitResp.reason === REFERRAL_CODE_API_FAIL_REASON.REFERRAL_CODE_NOT_FOUND) {
                setError(i18next.t('label.validate.referral_code_is_not_correct'));
            }

            if (
                submitResp?.reason === REFERRAL_CODE_API_FAIL_REASON.CAN_NOT_USE_SELF_REFERRAL_CODE
            ) {
                setError(i18next.t('label.validate.member_can_not_use_self_referral_code'));
            }

            setLoading(false);
        } else setError(i18next.t('label.validate.referral_code_is_required'));
    };

    return (
        <Dialog css={css(dialogStyle)} aria-labelledby="referral-code-dialog" open>
            <ReferralCodeCard
                onClick={handleClick}
                onClose={onClose}
                isLoading={isLoading}
                isShowCloseButton={isShowCloseButton}
                isShowImage={referralCodeCard.isShowImage}
                imageUrl={referralCodeCard.imageUrl}
                buttonText={referralCodeCard.buttonText}
                buttonTextColor={referralCodeCard.buttonTextColor}
                buttonBgColor={referralCodeCard.buttonBgColor}
                description={referralCodeCard.description}
                themeTextColor={referralCodeCard.themeTextColor}
                themeBgColor={referralCodeCard.themeBgColor}
                title={i18next.t('label.referral_card_title')}
                placeholder={i18next.t('placeholder.enter_referral_code')}
                value={value}
                error={error}
                onChange={e => {
                    setValue(e?.target?.value);
                }}
            />
        </Dialog>
    );
}

const dialogStyle = css`
    & .MuiDialog-paper {
        border-radius: 12px;
    }
`;
